import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import MainTabsNav from '../components/MainTabsNav';
import AboutStampFit from '../components/AboutStampFit';
import { useAuthStore } from '../stores/authStore';

/**
 * 스탬핏이란? 독립 라우트(/about) — 광고 랜딩용.
 * Layout(Header/Footer) 안에서 메인 탭바 + 소개 랜딩을 보여준다.
 */
export default function AboutPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();

  return (
    <div className="bg-gray-50">
      <Helmet>
        <title>스탬핏이란? | STAMP FIT</title>
        <meta
          name="description"
          content="피트니스 교육부터 수료 인증, 강사 이력 관리 및 채용 연결까지 — STAMP FIT 소개"
        />
      </Helmet>

      <MainTabsNav />

      <div className="px-6 sm:px-10 lg:px-16">
        <AboutStampFit
          onExploreEducation={() => navigate('/?view=classes&tab=main')}
          onExploreJobs={() => navigate('/?view=jobs')}
          onExplorePremium={() => navigate('/premium-providers')}
          onStartInstructor={() =>
            navigate(isAuthenticated ? '/?view=classes&tab=main' : '/login?type=user')
          }
          onRegisterJob={() =>
            navigate(
              isAuthenticated ? '/employer/recruitment?tab=job-postings&new=1' : '/login?type=employer'
            )
          }
        />
      </div>
    </div>
  );
}
